import { defineClientModule, type ModuleRoute } from '@/app/module';
import { registerOfflinePrefetch } from '@/lib/query';
import { copy } from './copy';

/**
 * sessions ("runs"): weekly meetups, RSVP and the waitlist, check-in, the live day hub, the recap,
 * the courts library and the calendar link. See docs/design/add-sessions.md. This file stays light:
 * data and lazy imports only.
 */
const routes: ModuleRoute[] = [
  { path: '/runs', screen: () => import('./screens/Runs'), tab: 'play' },
  { path: '/runs/new', screen: () => import('./screens/RunNew'), tab: 'play' },
  { path: '/runs/courts', screen: () => import('./screens/Courts'), tab: 'play' },
  { path: '/runs/:id', screen: () => import('./screens/Run'), tab: 'play' },
  { path: '/runs/:id/edit', screen: () => import('./screens/RunEdit'), tab: 'play' },
  { path: '/runs/:id/live', screen: () => import('./screens/RunLive'), tab: 'play', layout: 'bare' },
  { path: '/runs/:id/recap', screen: () => import('./screens/Recap'), tab: 'play' },
];

export default defineClientModule({
  name: 'sessions',
  routes,
  homeCards: [{ id: 'nextRun', order: 0, component: () => import('./parts/NextRunCard') }],
  playSections: [{ id: 'runs', order: 0, component: () => import('./parts/RunsStrip') }],
  playHubTiles: [
    {
      id: 'runs',
      order: 5,
      title: copy.runs.title,
      sub: copy.strip.all,
      to: '/runs',
      color: 'butter',
      icon: 'calendar',
    },
  ],
  meSections: [
    { id: 'calendar', order: 25, title: copy.calendar.title, component: () => import('./parts/CalendarSection') },
  ],
  profileSections: [
    { id: 'attendance', order: 10, title: copy.attendance.title, component: () => import('./parts/Attendance') },
  ],
  init() {
    // Replay RSVPs and check-ins that were tapped with no signal, and keep the next and live runs
    // on the phone before it goes into a gym with no bars.
    void import('./sync').then((m) => m.startSessionsQueue());
    registerOfflinePrefetch('sessions.runs', (qc) => import('./queries').then((m) => m.prefetchRuns(qc)));
  },
});
